/* eslint-disable */

import {Box, Card, Grid, Tooltip, Typography, withStyles} from "@material-ui/core";
import indicadoresFinancierosImage from "../../../../../assets/icons/indicarores_financieros.png";
import Chart from "react-apexcharts";
import Logo from "./Logo";
import {useTheme} from "@material-ui/core/styles";
import {useStyles} from "../../style";
import InfoIcon from "@material-ui/icons/Info";
import operacionalIcon from "../../../../../assets/icons/operacionalIcon.svg";
import React from "react";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const BarDonutOpIF = ({ info }) => {

    console.log("IFunits", info)
    const theme = useTheme();
    const classes = useStyles([]);

    const buildStyles = (data) => {
        console.log("data", data)
        const tmpChrtStl = {
            options: {
                chart: {
                    background: 'transparent',
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                    zoom: false,
                },
                plotOptions: {
                    radialBar: {
                        inverseOrder: false,
                        startAngle: 0,
                        endAngle: 360,
                        value: false,
                        track: {
                            background: '#dbdcdc',
                            strokeWidth: '130%',
                        },
                        dataLabels: {
                            showOn: 'always',
                            name: {
                                offsetY: 140,
                                show: true,
                                color: '#034886',
                                fontSize: '15px',
                                fontWeight: 700,
                            },
                            value: {
                                formatter: function(val){
                                    if (data.type === "percentage"){
                                        return `${val.toFixed(2)}%`
                                    }else if (data.type === "number"){
                                        return val.toFixed(2)
                                    }else if(data.type === "money"){
                                        return `$${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}`
                                    }
                                },
                                color: '#034886',
                                fontSize: '22px',
                                show: true,
                                offsetY: -5,
                                fontWeight: 700,
                            },
                        },
                        hollow: {
                            size: '55%',
                        },
                    },
                },
                colors: ['#034886','#034886'],
                dataLabels: {
                    enabled: false,
                },
                labels: [''],
                stroke: {
                    width: 0,
                },
                theme: {
                    mode: theme.palette.mode,
                },
            },
            series: data.series,
        };
        return tmpChrtStl
    }

    return (
        <Box>
            <Grid
                sx={{
                    p: 1,
                    height: '100%',
                    width: '100%',
                }}
                container
                component={Card}
                className={classes.indicadoresFinancieros}
            >
                {/* imagen */}
                <Grid
                    item
                    xs={12}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Box display="flex" justifyContent="center" style={{ paddingTop: '10px' }}>
                        <Box py={2} display="flex">
                            <Box mr={1}>
                                <img src={operacionalIcon} alt="operacionalIcon" width="35px" height="35px"/>
                            </Box>
                            <Typography className={classes.chartBarDonutTitle}>Operacional</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid container spacing={2}>
                    {info.map(dataGraph => {
                        const chartStyle = buildStyles(dataGraph);
                        return (
                            <Grid
                                item
                                xs={4}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    height: '100%',
                                }}
                            >
                                <Box display="flex" justifyContent="center">
                                    <Box>
                                        <Box pr={1} display="flex" justifyContent="end">
                                            <LightTooltip title={dataGraph.definition}>
                                                <InfoIcon style={{color: "#FCBE00"}}/>
                                            </LightTooltip>
                                        </Box>
                                        <Box display="flex" alignItems="center" justifyContent="center" >
                                            <Typography className={classes.chartBarDonutText} textAlign={'center'}>
                                                {dataGraph.indicador}
                                            </Typography>
                                        </Box>
                                        <div className={classes.chartBarCost}>
                                            <Chart
                                                height="300px"
                                                width="300px"
                                                type="radialBar"
                                                {...chartStyle}
                                            />
                                        </div>
                                    </Box>
                                </Box>
                            </Grid>)
                    })}
                </Grid>
            </Grid>
        </Box>
    )
};

export default BarDonutOpIF;